<script setup lang="ts">
import { PET_TYPE } from "../../store/variables";
import { defineProps, withDefaults } from "vue";
import { ProductGroup } from "../../classes/productGroup";
import { PetType } from "../../classes/petType";

interface Props {
  petName: string;
  liability: boolean;
  productGroup: ProductGroup;
  selectedPetType: PetType;
}

const props = withDefaults(defineProps<Props>(), {
  product: undefined,
  liability: false,
  productGroup: undefined,
  selectedPetType: undefined,
});
</script>

<template>
  <div class="quote-name" :class="{ liability: props.liability }">
    <template v-if="props.petName">
      <template v-if="props.liability">
        <div>
          Möchten Sie {{ props.petName }} auch gleich Haftpflicht versichern?
        </div>
        <div class="liability-circle">
          <span>50% sparen</span>
        </div>
      </template>
      <template v-else
        >{{ props.productGroup.name }}-Tarife für {{ props.petName }}</template
      >
    </template>
    <template v-else>
      Tarife {{ props.productGroup.name }} für
      {{ props.selectedPetType.id === PET_TYPE.DOG ? "Hunde" : "Katzen" }} im
      Vergleich
    </template>
  </div>
</template>

<style scoped lang="scss">
@import "../../styles/variables";

.quote-name {
  grid-area: b;
  padding: 0 0 24px 0;
  font-family: var(--font-roboto-bold), sans-serif;
  font-size: 20px;
  line-height: 32px;
  text-align: center;

  &.liability {
    display: flex;
  }

  @media screen and (min-width: $breakpoint-m) {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-end;
    padding: 0 20px 20px 0;
    text-align: left;
  }
  @media screen and (max-width: $breakpoint-m - 1px) {
    margin-top: 32px;
  }

  .liability-circle {
    position: relative;
    min-width: 64px;
    height: 64px;
    border-radius: 50%;
    background: var(--color-blue-600);
    color: var(--color-white);
    font-size: 16px;
    display: flex;
    text-align: center;
    align-items: center;
    align-self: end;
    line-height: 16px;
    font-family: var(--font-roboto-medium), sans-serif;

    span {
      position: absolute;
    }
  }
}
</style>
